var exports = {
  "k": "VoiceVideoTabInline.module__container___T0s2Q2",
};

module.exports = exports;
